import { assertKeepAwakeEnabled, assertKeepAwakeTag } from "./validate";
function isEnabled() {
  return Promise.resolve(false);
}
function setEnabled(enabled) {
  assertKeepAwakeEnabled(enabled);
  return Promise.resolve();
}
function activate(tag) {
  assertKeepAwakeTag(tag, "activate");
  return Promise.resolve();
}
function deactivate(tag) {
  assertKeepAwakeTag(tag, "deactivate");
  return Promise.resolve();
}
var KeepAwake = Object.freeze({
  isEnabled,
  setEnabled,
  activate,
  deactivate
});
export {
  KeepAwake
};
//# sourceMappingURL=unavailable.js.map
